var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white sticky-header"},[_c('div',{staticClass:"py-3 m-0 subject-title align-items-center mobile"},[(_vm.show)?_c('span',{staticClass:"pr-2 close-button",on:{"click":_vm.back}},[_c('v-icon',{staticClass:"arrow-left",attrs:{"name":"chevron-left","scale":"1.2"}})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }